// extracted by mini-css-extract-plugin
export default {"booking":"BookingHistory_booking__rOLX-","titleContainer":"BookingHistory_titleContainer__JEfr-","cossf":"BookingHistory_cossf__wqmCj"};